import { render, staticRenderFns } from "./StartForm8.vue?vue&type=template&id=666fb772&scoped=true"
import script from "./StartForm8.vue?vue&type=script&lang=ts"
export * from "./StartForm8.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666fb772",
  null
  
)

export default component.exports